<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="编辑部门"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="420px"
  >
    <div class="dialog__container edit-department">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
			<el-form-item label="部门名称：" prop="departmentName">
			  <el-input
			    size="mini"
			    v-model.trim="form.departmentName"
			    placeholder="请输入部门名称："
			    clearable
			  ></el-input>
			</el-form-item>
				<el-form-item label="排序号：">
				  <el-input
				    size="mini"
				    v-model.trim="form.level"
				    placeholder="请输入排序号"
				    clearable
				  ></el-input>
				</el-form-item>
      </el-form>
      <el-tree
        :show-checkbox="true"
        node-key="projectId"
        :data="projectLevel"
        :props="defaultProps"
        :default-checked-keys="defaultProjectList"
        ref="tree"
        @check="handleCheckChange">
      </el-tree>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { editDepartment, getProjectIdByDepartment, getProjectLiftTree, getDepartmentDetail } from '@/api/UnitManagement'
export default {
  name: 'EditDepartment',
  data() {
    return {
      form: {
        departmentName: '',
        level: '',
      },
      rules: {
        departmentName: [
          {
            required: true,
            message: '请输入部门名称',
            trigger: 'blur'
          }
				]
      },
      loadBtn: false,
      defaultProjectList: [],
      defaultProps: {
        label: 'name',
        children: 'liftList'
      },
      selectLifts: [],
      liftListLengths: 0,
      projectList: []
    }
  },
  props: {
    editData: {
      type: Object,
      required: true
    },
    unitId: {
      required: true
    }
  },
  created() {
    this.getDepartmentDetail()
    this.getProjectLiftTree()
    this.getProjectIdByDepartment()
    console.log(this.editData)
  },
  computed: {
    projectLevel: function() {
      this.liftListLengths = 0;
      if (this.projectList && this.projectList.length) {
        this.projectList.map(item => {
          item.name = `${item.projectName} (${item.liftList.length})`;
          item.liftList.map(lift => {
            lift.name = lift.liftName;
          })
          this.liftListLengths += item.liftList.length;
        });
        return this.projectList;
      }
      return [];
    }
  },
  methods: {
    async getDepartmentDetail() {
      const res = await getDepartmentDetail({ departmentId: this.editData.id })
      if (res.code === 200) {
        this.form = res.data
      }
    },
    async getProjectLiftTree() {
      const res = await getProjectLiftTree({ unitId: this.unitId, departmentId: this.editData.parentId })
      if (res.code === 200) {
        this.projectList = res.data
      }
    },
    handleBeforeClose(done) {
      this.$emit('cancel')
      done()
    },
    handleCancel() {
      this.$emit('cancel')
    },
    async getProjectIdByDepartment() {
      const idList = [this.editData.id];
      const res = await getProjectIdByDepartment(idList);
      if (res.code === 200) {
        this.defaultProjectList = res.data
      }
    },
    async handleConfirm() {
      if (this.loadBtn) return
      this.handleCheckChange()
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.loadBtn = true
          this.form.level *= 1
          this.form.unitId = this.unitId
          this.form.parentId = this.editData.parentId
          const res = await editDepartment(this.form)
          if (res.code === 200) {
            this.$message.success('编辑成功')
            this.$emit('confirm')
          }
          this.loadBtn = false
        }
      })
    },
    handleCheckChange() {
      const checkResult = this.$refs.tree.getCheckedNodes(false, true);
      this.selectLifts = [];
      const check = {
        checkPeojectName: [],
        checkPeojectId: [],
      }
      checkResult.forEach((item) => {
        if (!item.liftId) {
          check.checkPeojectName.push(item.projectName);
          check.checkPeojectId.push(item.projectId);
        } else {
          this.selectLifts.push(item.liftId);
        }
      });
      this.form.projectIdList = check.checkPeojectId
    }
  }
}
</script>
<style lang="scss">
.edit-department {
  .el-tree-node__children {
  .el-checkbox {
    display: none;
  }
}
}

</style>



// WEBPACK FOOTER //
// src/pages/DepartmentManagement/components/EditDepartment.vue